module.exports = __webpack_public_path__ + "static/media/Danustan_Alphonza_I_Can_See_the_Tower.b3b0fda4.jpg";